import React, { useState, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import {
  OrderBox,
  OrderListWrapper,
  OrderList,
  OrderDetailsWrapper,
  ItemWrapper,
  ItemDetails,
  ItemName,
  ItemSize,
  ItemPrice,
  NoOrderFound,
} from "./Order.style";
import { convertDate, convertDatePlacedOrder, convertTime24to12 } from "../../../constants/Constant";
import OrderDetails from "./SingleOrderDetails/OrderDetails";
import OrderCard from "./OrderCard/OrderCard";
import OrderCardMobile from "./OrderCard/orderCardMobile";
import useComponentSize from "../../../helper/useComponentSize";
import t from '../../../i18n/translate';
import reactStringReplace from 'react-string-replace';
import Button from "../../../components/Button/Button";
import Modal from 'react-bootstrap/Modal';
import {useCart} from "../../../contexts/cart/use-cart";
import abaIcon from "../../../assets/icons/abapay.png";
import cashIcon from "../../../assets/icons/cash.png";
import OrderTableColumns from "../../../components/Orders/orderTableColumns";

/*
 * status = 0 => Order Saved
 * status = 1 => Order Removed
 * status = 2 => Order Pending
 * status = 3 => Order Processing
 * status = 4 => Order Pick Up
 * status = 5 => Order Delivering
 * status = 6 => Order Delivered
 * status = 7 => Order Canceled
 * status = 8 => Order Arrived
 */
const statusData = ["Saved", "Removed", "Pending", "Processing", "Pick Up", "Delivering", "Delivered", "Canceled", "Arrived"];

const OrdersContent = ({
  deviceType: { mobile, tablet, desktop },
  props,
  currentorders,
  currentorderDetails,
  tabactive,
  listPaymentMethod
}) => {
  const { fetchOrderItems } = useCart();
	const columns = OrderTableColumns();
  const [order, setOrder] = useState(null);
  const [active, setActive] = useState("");
  const lang = localStorage.getItem('lang') || 'en';
  const [targetRef, size] = useComponentSize();
  const orderListHeight = size.height - 79;
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState(t('shop_order_list_re_order_success_content_dialog'));
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (currentorders && currentorders.length !== 0) {
      if (tabactive == "currentOrder") {
        const getNotificationID = localStorage.getItem("notificationID");
        props.fetchParticularOrder({ order_id: getNotificationID ?? currentorders[0].order_id, lang });
        setOrder(currentorderDetails);
        if (getNotificationID) {
          setActive(parseInt(getNotificationID));
          const card = document.getElementById(`order${getNotificationID}`);
          let timeout;
          timeout = timeout = setTimeout(() => {
            if(card){
              card.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            localStorage.removeItem("notificationID");
          }, 1000);
          return () => { clearTimeout(timeout); };
        } else {
          setActive(currentorders[0].order_id);
        }
      }
    }
  }, [currentorders, tabactive]);

  useEffect(() => {
    if (currentorders && currentorders.length !== 0) {
      setOrder(currentorderDetails);
    }
  }, [currentorderDetails, tabactive]);

  useEffect(() => {
    let user = localStorage.getItem("user");
    let parsedUser = JSON.parse(user);
    if (parsedUser) {
      let cust_id = parsedUser.cust_id;
      props.currentOrders({ cust_id: parsedUser.cust_id, lang });
    }
  }, [tabactive]);

  const handleClick = (order) => {
    props.fetchParticularOrder({ order_id: order.order_id, lang });
    setOrder(currentorderDetails);
    setActive(order.order_id);
  };

  const handleOnError = (eventData) => {
    setMessage(reactStringReplace(eventData, /(\n)/g, () => <br />));
    setIsError(true);
    setShow(true);
  }
  const handleOnSuccess = (eventData) => {
    setShow(true);
  }

  const handleModalClose = () => {
    setShow(false);
    setIsError(false);
    props.resetreordersuccess();
    localStorage.setItem("reordered", true);
    fetchOrderItems( props.cartType );
    if(!document.getElementsByClassName("cartPopupFixed").length) {
      document.getElementsByClassName("product-cart")[0].click();
    }
  };

  const getPaymentLogoDisplay = (paymentMethodName, paymentOption) => {
    if (paymentMethodName?.includes("Paid online") && paymentOption !== "ABA_PAY") {
      return listPaymentMethod?.find(item => item?.bic === paymentOption)?.img_url;
    } else if (paymentMethodName === "Pay on delivery" || paymentMethodName === "" || paymentMethodName === null) {
      return cashIcon;
    } else {
      return abaIcon;
    }
  }

	const customerAddress = (order) => {
		if (order.list_customer_addresses && order.list_customer_addresses.length > 0) {
			return order.list_customer_addresses[0];
		} else {
			return order.list_customer_address;
		}
	};

  return (
    <OrderBox>
      {window.innerWidth > 768 ? (
        <>
          {/*Order list right side panel*/}
          <OrderListWrapper style={{ height: size.height }}>
            <Scrollbars
              universal
              autoHide
              autoHeight
              autoHeightMin={420}
              autoHeightMax={isNaN(orderListHeight) ? 500 : orderListHeight}
            >
              <OrderList>
                {currentorders != undefined && currentorders.length !== 0 ? (
                  currentorders.map((order) => (
                    <OrderCard
                      progressBox={statusData}
                      props={props}
                      key={order.order_id}
                      orderId={order.order_id}
                      className={
                        `${order.type ? "express" : "normal"} ${order && order.order_id === active ? "active" : ""}`
                      }
                      status={order.status}
                      date={convertDate(
                        order.placedAt.split(":")[0].split(" ")[0]
                      )}
                      time={convertTime24to12(
                        order.placedAt.split(" ")[1]
                      )}
                      // deliveryTime={order.deliveryTime}
                      amount={
	                      // Calculate rest to pay (without driver tip)
	                      Number(order.item_total || 0) +
	                      Number(order.delivery_fee || 0) -
	                      Number(order.coupon_discount_amount || 0) -
	                      Number(order.wallet_payment || 0) -
	                      Number(order.dp_discount_payment || 0)
                      }
                      paymentMethodLogo={getPaymentLogoDisplay(order.payment_method_name, order.order_payment_details[0]?.payment_option)}
                      onClick={() => {
                        handleClick(order);
                      }}
                      type="current_orders"
                      onError={handleOnError}
                      onSuccess={handleOnSuccess}
                    />
                  ))
                ) : (
                  <NoOrderFound>
                    { t('shop_order_list_end_of_orders_historic') }
                  </NoOrderFound>
                )}
              </OrderList>
            </Scrollbars>
          </OrderListWrapper>

          <OrderDetailsWrapper ref={targetRef}>
            {order && order.order_id && (
              <OrderDetails
                progressStatus={order.status}
                progressBox={statusData}
                pageType={"current-order"}
                name={
	                customerAddress(order)?.first_name +
                  " " +
	                customerAddress(order)?.last_name
                }
                phone={customerAddress(order)?.mobile_number}
                country_code={customerAddress(order)?.country_code}
                delivery_slot={
	                order && order?.store_on_going_slots && typeof order?.store_on_going_slots !== 'undefined'
		                ? convertDate(order?.store_on_going_slots[0]?.Date) +
                    " | " +
                    convertTime24to12(
	                    order?.store_on_going_slots[0]?.start_time.split(" ")[1]
                    ) +
                    " - " +
                    convertTime24to12(
	                    order?.store_on_going_slots[0]?.end_time.split(" ")[1]
                    )
                    : null
                }
                address={customerAddress(order) || "n/a"}
                subtotal={order.item_total}
                discount={
                  order.order_payment_details[0].discount
                    ? order.order_payment_details[0].discount
                    : "0.00"
                }
                deliveryFee={order.delivery_fee}
                grandTotal={
	                Number(order.item_total || 0) +
	                Number(order.delivery_fee || 0) -
	                Number(order.coupon_discount_amount || 0) -
	                Number(order.wallet_payment || 0) -
	                Number(order.dp_discount_payment || 0)
                }
                comments={order.comments}
                tableData={order.order_item_details}
                columns={columns}
                props={props}
                orderId={order.order_id}
                type="current_orders"
                onError={handleOnError}
                onSuccess={handleOnSuccess}
                orderDetails={order}
              />
            )}
          </OrderDetailsWrapper>
        </>
      ) : (
        <OrderList className={props.cartType}>
          {currentorders != undefined && currentorders.length !== 0 ? (
            currentorders.map((order) => (
              <OrderCardMobile
                key={order.order_id}
                order={order}
                orderId={order.order_id}
                className={`${props.cartType} ${order && order.order_id === active ? "active" : ""}`}
                progressStatus={order.status}
                tableData={order.order_item_details}
                columns={columns}
                pageType={"current-order"}
                props={props}
                paymentMethodLogo={getPaymentLogoDisplay(order?.payment_method_name, order.order_payment_details[0]?.payment_option)}
                onClick={() => {
                  handleClick(order);
                }}
                type="current_orders"
                onError={handleOnError}
                onSuccess={handleOnSuccess}
                orderDetails={order}
              />
            ))
          ) : (
            <NoOrderFound>
              { t('shop_order_list_end_of_orders_historic') }
            </NoOrderFound>
          )}
        </OrderList>
      )}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{isError
            ? t('shop_checkout_alert_error')
            : t('shop_order_list_re_order_success_title_dialog')
          }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={isError ? {} : {color: "green"} }>
          { message }
        </Modal.Body>
        <Modal.Footer>
          <Button
            title={ t('shop_order_list_button_ok_dialog', false) }
            variant="primary"
            onClick={handleModalClose}
          >
            { t('shop_order_list_button_ok_dialog') }
          </Button>
        </Modal.Footer>
      </Modal>
    </OrderBox>
  );
};

export default OrdersContent;
